import { Popover } from "@mui/material";
import { MprcIconButton } from "components/MprcIconButton";
import { useState } from "react";

interface IProps {
    icon: React.ReactNode;
    iconColor?: MprcColors;
    content: (onClose: () => void) => React.ReactNode;
    title?: string;
}

type MprcIconButtonPopoverProps = IProps;

export const MprcIconButtonPopover: React.FC<MprcIconButtonPopoverProps> = ({ title, icon, iconColor, content }) => {

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'mprc-icon-button-popover' : undefined;

    return (
        <div>
            <MprcIconButton aria-describedby={id} onClick={handleClick} title={title} color={iconColor}>
                {icon}
            </MprcIconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {content(handleClose)}
            </Popover>
        </div>
    );
};
